'use client';

import {toast} from 'sonner';
import Toast from '../components/Toast/Toast';

type ToastData = {
  title?: string;
  description?: string;
  content?: string;
  state: 'error' | 'success';
  closeOnUndo?: boolean;
  duration?: number;
  onUndo?: () => void;
  onClose?: () => void;
  onAutoClose?: () => void;
};

const genericError = {
  en: {
    title: 'Something went wrong',
    description: 'Your action could not be completed'
  },
  da: {
    title: 'Noget gik galt',
    description: 'Din handling kunne ikke gennemføres'
  },
  no: {
    title: 'Noe gikk galt',
    description: 'Handlingen din kunne ikke fullføres'
  },
  sv: {
    title: 'Något gick fel',
    description: 'Din åtgärd kunde inte slutföras'
  }
};

const useToast = locale => {
  const emit = ({
    state,
    title,
    description,
    content,
    closeOnUndo = false,
    duration = 5000,
    onClose,
    onUndo,
    onAutoClose = () => {}
  }: ToastData) => {
    const toastData = {
      title: title || genericError[locale].title,
      content: description || content || genericError[locale].description,
      state,
      onUndo,
      onClose
    };

    const toastOptions = {
      duration,
      onDismiss: onClose,
      unstyled: true,
      onAutoClose
    };

    return toast.custom(t => {
      const onClose = () => {
        toast.dismiss(t);
        toastData.onClose?.();
      };

      const onUndo = () => {
        if (closeOnUndo) toast.dismiss(t);
        toastData.onUndo?.();
      };

      return (
        <Toast
          data={{
            ...toastData,
            withUndo: !!toastData?.onUndo,
            onUndo,
            onClose
          }}
        />
      );
    }, toastOptions);
  };

  return {
    toast: emit
  };
};

export default useToast;
